<div>
  <div class="mb-2">
    <es-document-download
      [validationMessages]="validationMessages"
      [isCanUploadDocuments]="isCanUploadDocuments"
      [isCanRemoveDocuments]="isCanRemoveDocuments"
      [document]="shipmentDocument"
      [attachmentTypeName]="billName"
      [attachmentName]="shipmentName"
      [id]="'upload-shipment-file-' + shipment.id"
      [isTruck]="isTruck"
      [upload]="upload"
      [remove]="remove"
      (stateUpdate)="onStateUpdate($event)"
    ></es-document-download>
  </div>

  <div class="mb-2" *ngFor="let invoice of shipment.invoices || []; let index = index">
    <es-invoice-attach-document
      [validationMessages]="validationMessages"
      [entrySummaryId]="entrySummaryId"
      [attachedDocuments]="attachedDocuments"
      [isCanUploadDocuments]="isCanUploadDocuments"
      [isCanRemoveDocuments]="isCanRemoveDocuments"
      [index]="index"
      [invoice]="invoice"
      [isShowEmptyLineItemDocuments]="isShowEmptyLineItemDocuments"
      [upload]="upload"
      [remove]="remove"
      (stateUpdate)="onStateUpdate($event)"
    ></es-invoice-attach-document>
  </div>

  <div class="mb-2" *ngFor="let document of otherDocuments; let index = index">
    <es-document-download
      [validationMessages]="validationMessages"
      [isCanUploadDocuments]="isCanUploadDocuments"
      [isCanRemoveDocuments]="isCanRemoveDocuments"
      [attachmentTypeName]="'DOCUMENT_TYPE.' + enumDocumentType[document.type]"
      [isShowDeferredRequiredTag]="document.type === enumDocumentType.ARRIVAL_NOTICE"
      [requiredLaterTooltip]="
        document.type === enumDocumentType.ARRIVAL_NOTICE ? 'ENTRY_SUMMARY.BILL_OF_LADING_DOCS.ARRIVAL_NOTICE.REQUIRED_LATER_TOOLTIP' : null
      "
      [id]="'upload-other-file-' + shipment.id + '-' + index"
      [document]="document"
      [upload]="upload"
      [remove]="remove"
      (stateUpdate)="onStateUpdate($event)"
    ></es-document-download>
  </div>

  <document-add-other
    *ngIf="isCanUploadDocuments"
    [createDocument]="createDocumentTemplate"
    [otherPossibleDocuments]="lineItemDocuments"
    [upload]="upload"
  ></document-add-other>
</div>
